module.exports = __webpack_public_path__ + "static/media/greenhouse3-03.c6fc1c30.webp";